import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useDispatch } from "react-redux";
import { notification } from "antd";
import { __hideLoader, __showLoader } from "../Redux Store/Slices/loader";
import { AuthUrl } from "../urls";
import { setTokens } from "../Redux Store/Slices/auth";
import useErrorHandler from "./useErrorHandler";
import { tempToast } from "../utils/toasts";

const useLoginForm = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [api, contextHolder] = notification.useNotification();
    const handleError = useErrorHandler();
    const handleLogin = async (values) => {
        tempToast();
        return;
        dispatch(__showLoader("Logging in..."));
        const data = {
            email: values.email,
            password: values.password,
            username: values.username,
            // username: "user123",
            // password: "StrongP@ssword1",
        };

        try {
            const response = await axios.post(AuthUrl.signin, data);
            api.open({
                message: "Notification",
                description: "Login successful!",
                duration: 0,
            });
            console.log({ response })
            const AuthenticationResult = response.data;
            // console.log({ response: response.data.AuthenticationResult.AccessToken })
            // console.log({ response: response.data.AuthenticationResult.IdToken })
            // console.log({ response: response.data.AuthenticationResult.RefreshToken })
            // todo: -> interceptors
            // todo: -> api get accesstoken
            // todo: -> logout
            // todo: -> payment integration

            dispatch(setTokens({
                access_token: AuthenticationResult.accessToken,
                refresh_token: AuthenticationResult.refreshToken,
            }));
            navigate("/dashboard");
        } catch (error) {
            handleError(error)
        } finally {
            dispatch(__hideLoader());
        }
    };

    return { handleLogin, contextHolder };
};


export default useLoginForm;